import React from "react";

import clsx from "clsx";

import { CurrentPoint } from "@/components/domains";
import { Button } from "@/components/inputs";
import { ProductModel } from "@/models/product/type";

import { OnlySubscriptionPanel } from "./OnlySubscriptionPanel";
import styles from "./ProductDetailSelects.module.scss";

interface ProductDetailSelectsProps {
  product: ProductModel;
  hasDifferentSalesTypeInCart: boolean;
  isLoggedIn: boolean;
  redirectToSubscription: () => void;
  handleClickDirect: () => void;
  handleClickCustomize: () => void;
}

/**
 * 認証情報で分岐のロジック、useClientFrontStoreCartItemsがあるのでwithCsrでラップ
 */
export function ProductDetailSelectsSet({
  product,
  hasDifferentSalesTypeInCart,
  isLoggedIn,
  redirectToSubscription,
  handleClickDirect,
  handleClickCustomize,
}: ProductDetailSelectsProps): React.ReactNode {
  return (
    <div>
      <OnlySubscriptionPanel
        firstPrice={product.firstSubscriptionPrice}
        afterSecondPrice={product.afterSecondSubscriptionPrice}
      />
      <CurrentPoint />
      {/* ログイン済みの状態であれば、「マイページで追加・変更」ボタンを表示 */}
      {isLoggedIn ? (
        <Button
          className={clsx(styles.mypageEditButton, "mg__top__s")}
          onClick={redirectToSubscription}
          variants={"primary"}
          fullWidth
          rounded
        >
          マイページで追加・変更
          <i className={clsx("fas fa-angle-right", styles.angleRight)} />
        </Button>
      ) : (
        <>
          <Button
            variants="primary"
            fullWidth
            rounded
            onClick={handleClickDirect}
            disabled={hasDifferentSalesTypeInCart}
            className="mg__top__s"
          >
            いますぐ購入
          </Button>
          <Button
            variants="secondary"
            rounded
            fullWidth
            disabled={hasDifferentSalesTypeInCart}
            onClick={handleClickCustomize}
            className="mg__top__s"
          >
            商品をカスタマイズする
          </Button>
        </>
      )}

      {hasDifferentSalesTypeInCart && !isLoggedIn && (
        <div className="text__s text__bold text__red mg__bottom__s mg__top__s text__center text__left__pc">
          アウトレット商品と通常商品を同時に購入することはできません。カートの中身をご確認ください。
        </div>
      )}
    </div>
  );
}
